import { render, staticRenderFns } from "./ajouterVidangeOkba.vue?vue&type=template&id=1185a59e&scoped=true&"
import script from "./ajouterVidangeOkba.vue?vue&type=script&lang=js&"
export * from "./ajouterVidangeOkba.vue?vue&type=script&lang=js&"
import style0 from "./ajouterVidangeOkba.vue?vue&type=style&index=0&id=1185a59e&lang=scss&scoped=true&"
import style1 from "./ajouterVidangeOkba.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1185a59e",
  null
  
)

export default component.exports